module.exports = __webpack_public_path__ + "img/i199.a1531009.png";